module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Medium.woff2?46d7404e4a2eb3cd2ff9bc83023e259c";